import { Contact, CountryWeSellTo } from 'apps-common/types';

// must be home address not billing address for checking tax in making PM
export const isExistingStateValid = (homeCountry: string | undefined, homeState: string | undefined | null) => {
  const stateRequiredCountries = ['US', 'CA', 'AE', 'JP'];
  const isStateRequiredCountry = stateRequiredCountries.includes(homeCountry ?? '');
  return isStateRequiredCountry ? !!homeState : true;
};

/*
 *  Existing valid address should have:
 * - valid state if country requires state
 * - valid supported country (VI,PR, GU are not supported)
 * - addressValidated flag set to true
 *
 * If any of the above conditions are not met, active/pending cancellation user can't update PM or rate plan
 * */

export const canUseExistingAddressForPaymentMethod = (
  homeContact: Contact | null,
  billingContact: Contact | null,
  countryData: CountryWeSellTo[],
): boolean => {
  if (!homeContact || !billingContact) {
    return false;
  }
  const validCountry = !!countryData?.some((country) => country.countryCode === homeContact.country);
  const validState = isExistingStateValid(homeContact.country, homeContact.state);

  return validCountry && validState && homeContact.addressValidated;
};
